<template>
  <div class="vacc">
    <common-head title="添加疫苗" />
    <van-empty image="search" description="暂无数据" v-if="!total.length" />
    <div class="my-wrap" v-else>
      <div class="cate one" v-if="immunizationPlanning.length">
        <van-divider>
          <span class="text">免疫规划疫苗（免费）</span>
        </van-divider>
        <div class="list">
          <div 
            :class="['item', {current: index == n1}]"
            v-for="(item, index) in immunizationPlanning"
            :key="index"
            @click="change(index, 'immunizationPlanning')"
          >
            <div class="top">
              <b class="my-b">{{ item.vaccineName }}</b>
              <van-tag plain type="success" class="tag">{{ item.sellPriceDes }}</van-tag>
            </div>
            <div class="my-text">{{ item.manufacturer }}</div>
          </div>
        </div>
      </div>

      <div class="cate two" v-if="notImmunizationPlanning.length">
        <van-divider>
          <span class="text">非免疫规划疫苗（自费）</span>
        </van-divider>
        <div class="list">
          <div 
            :class="['item', {current: index == n2}]"
            v-for="(item, index) in notImmunizationPlanning"
            :key="index"
            @click="change(index, 'notImmunizationPlanning')"
          >
            <div class="top">
              <b class="my-b">{{ item.vaccineName }}</b>
              <span class="price">{{ item.sellPriceDes }}</span>
            </div>
            <div class="my-text">{{ item.manufacturer }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="my-button" v-if="total.length" :disabled="!data">
      <van-button type="info" round @click="confirm">确认</van-button>
    </div> -->
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import { fetchVacc } from 'api/vacc'
import { validateImm } from 'api/appointment'
import { mapState } from 'vuex'

export default {
  components: {
    CommonHead
  },
  computed: {
    ...mapState(['key'])
  },
  data() {
    return {
      vaccineSupId: '',
      total: [],
      immunizationPlanning: [],
      notImmunizationPlanning: [],
      n1: -1,
      n2: -1,
      data: null
    }
  },
  watch: {
    show(value) {
      if (!value) {
        this.n1 = -1
        this.n2 = -1
        this.data = null
      }
    }
  },
  created() {
    this.getVacc()
  },
  methods: {
    // 直接获取疫苗小类
    getVacc() {
      switch (this.key) {
        case 'rabies':
          this.vaccineSupId = '28'
          break;
        case 'xg':
          this.vaccineSupId = '56'
          break;
        case 'flu':
          this.vaccineSupId = '21'
          break;
      }
      const params = {
        povCode: this.$route.query.povCode,
        profileCode: this.$route.query.profileCode,
        vaccineSupId: this.vaccineSupId
      }
      fetchVacc(params).then(res => {
        this.immunizationPlanning = res.data.filter(v => v.immunizationPlanning)
        this.notImmunizationPlanning = res.data.filter(v => v.notImmunizationPlanning)
        this.total = res.data
        // 处理默认选中
        if (this.immunizationPlanning.length) {
          this.n1 = 0
          this.data = this.immunizationPlanning[0]
        }
      })
    },
    // 选中高亮
    change(index, type) {
      if (type == 'immunizationPlanning') {
        // if (this.n1 == index) return
        this.n1 = index
        this.n2 = -1
        this.data = this.immunizationPlanning[index]
        if (!this.data.storeNum) {
          this.$store.commit('setVacc', null)
          this.$toast('该门诊暂无库存，请切换疫苗后预约')
          return
        }
        this.validate()
      } else {
        // if (this.n2 == index) return
        this.n2 = index
        this.n1 = -1
        this.data = this.notImmunizationPlanning[index]
        this.data.vaccineSupId = this.$parent.vaccineSupId
        this.$store.commit('setVacc', this.data)
        if (!this.data.storeNum) {
          this.$store.commit('setVacc', null)
          this.$toast('该门诊暂无库存，请切换疫苗后预约')
          return
        }
        setTimeout(() => {
          this.$router.push('/appointment')
        }, 300)
      }
    },
    // 选中免规苗时的校验
    validate() {
      const params = {
        profileCode: this.$route.query.profileCode,
        vaccineSupId: this.vaccineSupId
      }
      validateImm(params).then(res => {
        if (res.code !== 0) {
          this.$toast(res.message)
        } else {
          this.data.vaccineSupId = this.vaccineSupId
          this.$store.commit('setVacc', this.data)
          this.$router.push('/appointment')
        }
      })
    },
    // 确认选择
    // confirm() {
    //   this.$store.commit('setVacc', this.data)
    //   this.$router.push('/appointment')
    // }
  }
}
</script>

<style lang="less" scoped>
.vacc {
  // padding-bottom: 81px;
  .cate {
    margin-bottom: 13px;
    .text {
      font-size: 12px;
      color: #999;
      font-weight: 500;
      opacity: .85;
    }
    .list {
      .item {
        height: 56px;
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 0 11px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        margin-bottom: 11px;
        &:last-child {
          margin-bottom: 0;
        }
        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .my-b {
            flex: 4,
          }
          .price {
            flex: 1;
            text-align: right;
            color: var(--orange);
            font-weight: bold;
            opacity: .9;
          }
        }
      }
      .current {
        border-color: var(--blue);
      }
    }
  }
}
</style>